import React from 'react';
import PageContainer from '../../common/components/Page/PageContainer';
import InstrumentStateTypesContainer from './components/InstrumentStateTypes/InstrumentStateTypesContainer';
import PermissionsCheck from '../../common/components/PermissionsCheck/PermissionsCheck';
import PermissionsEnum from '../../common/constants/PermissionsEnum';
import './AlertsConfiguration.css';

const AlertsConfiguration = () => (
  <PageContainer pageName="status-alert-configuration">
    <PermissionsCheck appliedToPage={true} permission={PermissionsEnum.VIEW_ALERT_CONFIGURATION}>
      <InstrumentStateTypesContainer />
    </PermissionsCheck>
  </PageContainer>
);

export default AlertsConfiguration;
